<div>
  <kendo-listview
    #listView
    [kendoListViewBinding]="composeStore.notInMaximizer()"
    [pageable]="showPagerNavigation()"
    [pageSize]="pageSize"
    class="border-none main-page"
  >
    <ng-template kendoListViewItemTemplate let-email="dataItem">
      <div class="rounded flex items-center justify-between py-1.5 gap-2">
        <div class="flex gap-2">
          <div
            class="bg-neutral-20 rounded-sm w-8 h-8 flex items-center justify-center"
          >
            <span
              class="fa-icons icon-solid icon-16 icon-user text-white"
            ></span>
          </div>
          <div class="flex flex-col max-w-[180px]">
            <p class="text-body line-clamp-1">
              {{ email.displayName }}
            </p>
            <p class="caption text-neutral-70 line-clamp-1">
              {{ email.emailAddress }}
            </p>
          </div>
        </div>
        <kendo-dropdownbutton
          id="outlook-main-ui-compose-createEntry-{{ email.emailAddress }}"
          [title]="'outlook.main.tooltip.add-entry' | translate"
          [data]="addEntryMenuItems"
          themeColor="primary"
          fillMode="flat"
          iconClass="fa-icons icon-solid icon-16 icon-plus"
          [popupSettings]="{ appendTo: viewContainerRef }"
          (itemClick)="
            navigateToAdd($event, email.emailAddress, email.displayName)
          "
        >
          <ng-template kendoDropDownButtonItemTemplate let-dataItem>
            <div
              id="outlook-main-ui-compose-add{{ dataItem.id | titlecase }}-{{
                email.emailAddress
              }}"
              class="flex items-center gap-1 w-full"
              kendoTooltip
              [tooltipTemplate]="tooltipTemplate"
              position="top"
              [callout]="false"
              [showOn]="dataItem.disabled ? 'hover' : 'none'"
              [title]="
                'outlook.rights.defaultMessage'
                  | translate
                    : {
                        right: 'outlook.rights.create' | translate,
                        entry:
                          dataItem.id === EntryType.Individual
                            ? ('individuals' | translateVertical)
                            : (dataItem.title | translate),
                      }
              "
            >
              <span [class]="dataItem.icon" class="w-6"></span>
              <p>
                @if (dataItem.id === EntryType.Individual) {
                  {{
                    'outlook.main.actions.addIndividual'
                      | translate
                        : {
                            label: 'individual' | translateVertical,
                          }
                  }}
                } @else {
                  {{ dataItem.text | translate }}
                }
              </p>
            </div>
          </ng-template>
        </kendo-dropdownbutton>
      </div>
    </ng-template>
  </kendo-listview>
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
